export default __webpack_public_path__ + "static/media/boxes.4135ef5c.png";